import { ApplicationConfig, isDevMode } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import {
  CORE_PROVIDERS,
  createAuthProviders,
} from '@nomoh-monorepo/shared-util-angular-config';
import { provideI18n } from '@nomoh-monorepo/data-access-shared-i18n';
import { LuxonNomoh } from '@nomoh-monorepo/shared-util-luxon-nomoh';
import { AuthService, authInterceptor, PUBLIC_ROUTES } from '@nomoh-monorepo/data-access-auth';
import { httpConfigInterceptor } from '@nomoh-monorepo/shared-interceptors';
import { appRoutes } from './app.routes';

// Chame a configuração do Luxon antes de inicializar a aplicação
LuxonNomoh.configureLuxon();

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withComponentInputBinding()),
    ...CORE_PROVIDERS,

    // Auth + HTTP Config (withCredentials + Accept-Language)
    ...createAuthProviders(AuthService, authInterceptor, httpConfigInterceptor),

    provideI18n('bardo-cliente'),
    {
      provide: PUBLIC_ROUTES,
      useValue: ['/login', '/cadastrar', '/recuperar-senha', '/privacidade'],
    },
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};
